const FORMULA_PREFIXES = ["=", "+", "-", "@", "\t", "\r"];

export const escapeCsvValue = (value: string | number): string => {
  const str = String(value);

  // Mitigate CSV formula injection: prefix dangerous characters so
  // spreadsheet apps don't interpret the cell as a formula.
  const sanitized = FORMULA_PREFIXES.some(p => str.startsWith(p)) ? `'${str}` : str;

  if (sanitized.includes(",") || sanitized.includes('"') || sanitized.includes("\n") || sanitized.includes("\r")) {
    return `"${sanitized.replace(/"/g, '""')}"`;
  }
  return sanitized;
};

export const downloadCsv = (csvContent: string, filename: string) => {
  const BOM = "\uFEFF";
  const blob = new Blob([BOM + csvContent], { type: "text/csv;charset=utf-8;" });

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${filename}-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
